<template>
<div>
  <addUser></addUser>
</div>
</template>

<script>
import addUser from '@/views/accountManagement/addUser';
export default {
  name: 'index',
  components:{addUser},
  data() {
    return {

    };
  },
  methods: {

  }
};
</script>

<style scoped>

</style>
